module.exports = __webpack_public_path__ + "media/components/country-flag/static/vc-4529ec93462400324cfbfdf9e7c3eb5b.svg";